import React from 'react';
import { arrayOf, bool, func, number, oneOfType, shape, string } from 'prop-types';
import { MAutocomplete } from 'common';

// Shared clearable single-select dropdown used for the Customer Info State/City/Zip fields
const LocationAutocomplete = ({
  disabled,
  helperText,
  id,
  label,
  loading,
  name,
  onChange,
  options,
  value,
}) => (
  <MAutocomplete
    disabled={disabled}
    fullWidth
    helperText={helperText}
    id={id}
    label={label}
    loading={loading}
    name={name}
    onChange={onChange}
    options={options}
    sx={{ flex: 1 }}
    value={value ?? null}
  />
);

LocationAutocomplete.propTypes = {
  disabled: bool,
  helperText: string,
  id: string.isRequired,
  label: string.isRequired,
  loading: bool,
  name: string.isRequired,
  onChange: func.isRequired,
  options: arrayOf(shape({})).isRequired,
  value: oneOfType([string, number]),
};

LocationAutocomplete.defaultProps = {
  disabled: false,
  helperText: '',
  loading: false,
  value: null,
};

export default LocationAutocomplete;
